// https://vuex.vuejs.org/en/actions.html

import userService from "@/service/userService";

const actions = {
    async initApp(context) {
        context.commit('setUser', userService.getUser());
    },
    async login({commit}, loginData) {
        const userData = await userService.login(loginData);
        if (!userData) {
            return false;
        }

        commit('setAuthenticated', true);
        commit('setRoles', userData.roles || []);
        commit('setLogoutReason', undefined);
        return true;
    },
    logout({commit}, logoutReason) {
        userService.logout();
        commit('logout');
        commit('setLogoutReason', logoutReason);
    },
    saveLanguage({commit}, payload) {
        commit('onLanguageChanged', payload);
    },
    setOffline({commit}, isOffline) {
        commit('setOffline', isOffline)
    }
}

export default actions
